/** @format */

/* eslint-disable */
import React, { useEffect, useState } from 'react'
import Loader from '../../../../Components/Loaders/Loader'
import { LoanProductLookup } from '../../../../Components/Lookup/LoanProductLookup'
import ModalTemplate from '../../../../Components/ModalTemplate/ModalTemplate'
import { CustomerPartial } from '../../../../Components/ReUsables/Customer/CustomerPartial'
import Tab from '../../../../Components/Tabs/Tab'
import localize from '../../../../Global/Localize'
import { showNotification } from '../../../../Helpers/Notification/ShowNotification'
import { getData, postData, putData } from '../../../../Helpers/webApi'
import { GlobalValidationErrors } from '../../../../Validation/ValidationState'
import ExemptedCustomers from './ExemptedCustomers'

function LoanProductsExemptionsModal({
  mode,
  onHideModal,
  onSetMode,
  selectedLoanProductExemption,
  setSelectedLoanProductExemption,
  loadTableData,
}) {
  const [gbv, setGbv] = GlobalValidationErrors.use({})
  const [selectedCustomer, setSelectedCustomer] = useState(null)
  const [exemptionEntriesToBeRemoved, setExemptionEntriesToBeRemoved] =
    useState([])
  const [customRemarks, setCustomRemarks] = useState(null)
  const [loanProductExemptionEntries, setLoanProductExemptionEntries] =
    useState([])

  const [loadTabData, setLoadTabData] = useState(false)
  const [reqParams, setReqParams] = useState({
    loanProductExemptionId: selectedLoanProductExemption?.id,
    filterText: '',
    customerFilter: 0,
    pageIndex: 0,
    pageSize: 10,
  })
  const [tableMeta, setTableMeta] = useState({ ...reqParams, itemsCount: 0 })
  const [isBusy, setIsBusy] = useState(false)

  useEffect(() => {
    if (mode !== 'add') {
      getLoanProductExemptionEntries()
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    reqParams.pageIndex,
    reqParams.pageSize,
    selectedLoanProductExemption?.id,
  ])

  const getLoanProductExemptionEntries = async () => {
    setLoadTabData(true)
    const { success, data } = await getData(
      '/LoanProductExemption/find-loan-product-exemption-entries-by-loan-product-exemption-id-in-page',
      reqParams,
      false
    )
    if (success) {
      setLoanProductExemptionEntries(data.pageCollection)
      setTableMeta({ ...reqParams, itemsCount: data.itemsCount })
    }
    setLoadTabData(false)
  }

  async function handleSubmit() {
    setIsBusy(true)
    const { success } =
      mode === 'edit'
        ? await putData(
            '/LoanProductExemption/update-loan-product-exemption-with-exemption-entries',
            {
              loanProductExemption: selectedLoanProductExemption || {},
              loanProductExemptionEntryDTOs: loanProductExemptionEntries,
            },
            false
          )
        : await postData(
            '/LoanProductExemption/create-loan-product-exemption-with-exemption-entries',
            {
              loanProductExemption: selectedLoanProductExemption || {},
              loanProductExemptionEntryDTOs: loanProductExemptionEntries,
            },
            false
          )

    if (success) {
      onSetMode(null)
      loadTableData()
      showNotification('Loan Product Exemption', 'success')
    }
    setIsBusy(false)
  }

  function clearValidation(column) {
    setGbv(g => {
      delete g[column]
      return g
    })
  }

  const addLoanProductExemptionEntry = customer => {
    if (!customer) {
      return
    }

    if (
      loanProductExemptionEntries.find(
        entry => entry.customerId === customer.id
      )
    ) {
      return showNotification(
        'Loan Product Exemption',
        'error',
        'Customer Entry Already Exists'
      )
    }
    setLoanProductExemptionEntries([
      ...loanProductExemptionEntries,
      {
        customerId: customer.id,
        id: customer.id,
        customerFullName: customer.fullName,
        customerMembershipClassCustomerType:
          customer.membershipClassCustomerType,
        customerSerialNumber: customer.serialNumber,
        customerIndividualSalutation: customer.individualSalutation,
        customerIndividualFirstName: customer.individualFirstName,
        customerIndividualLastName: customer.individualLastName,
        customerIndividualGender: customer.individualGender,
        customerIndividualMaritalStatus: customer.individualMaritalStatus,
        customerMembershipClassCustomerTypeDescription:
          customer.membershipClassDescription,
        paddedCustomerSerialNumber: customer.paddedSerialNumber,
        customerReference1: customer.reference1,
        customerReference2: customer.reference2,
        customerReference3: customer.reference3,
        customerIndividualGenderDescription:
          customer.individualGenderDescription,
        customerIndividualMaritalStatusDescription:
          customer.individualMaritalStatusDescription,
        customerIndividualIdentityCardNumber:
          customer.individualIdentityCardNumber,
        customerIndividualNationalityDescription:
          customer.individualNationalityDescription,
        customerDutyStationDescription: customer.dutyStationDescription,
        customerAddressAddressLine1: customer.addressAddressLine1,
        customerAddressAddressLine2: customer.addressAddressLine2,
        customerAddressStreet: customer.addressStreet,
        customerAddressPostalCode: customer.addressPostalCode,
        customerAddressCity: customer.addressCity,
        customerAddressEmail: customer.addressEmail,
        customerAddressLandLine: customer.addressLandLine,
        customerAddressMobileLine: customer.addressMobileLine,
        remarks: customRemarks?.remarks,
        createdBy: customer.createdBy,
        createdDate: customer.createdDate,
      },
    ])
    setSelectedCustomer(null)
    setCustomRemarks({ remarks: '' })
  }

  const removeExemptionEntry = customer => {
    setLoanProductExemptionEntries(
      loanProductExemptionEntries.filter(entry => entry.id !== customer.id)
    )
  }

  const removeExemptionEntryInEditMode = async () => {
    if (exemptionEntriesToBeRemoved.length === 0) {
      return showNotification(
        'Loan Product Exemption Entry',
        'error',
        'Select Atleast One Entry'
      )
    }
    setLoadTabData(true)
    const { success } = await putData(
      '/LoanProductExemption/remove-loan-product-exemption-entry',
      { LoanProductExemptionEntry: exemptionEntriesToBeRemoved },
      false
    )
    if (success) {
      setExemptionEntriesToBeRemoved([])
      getLoanProductExemptionEntries()
      showNotification('Loan Product Exemption', 'success')
    }
    setLoadTabData(false)
  }

  const handleOnSelectCustomer = customer => {
    if (customer?.isLocked) {
      setSelectedCustomer(null)
      return showNotification(
        'Loan Product Exemption',
        'error',
        'Sorry, but the selected Customer is Locked'
      )
    } else if (customer?.recordStatus !== '2') {
      setSelectedCustomer(null)
      return showNotification(
        'Loan Product Exemption',
        'error',
        'Sorry, but you must select a record whose status is approved'
      )
    } else {
      setSelectedCustomer({ ...customer })
    }
  }

  const addLoanProductExemptionEntryInEditMode = async customer => {
    const customerExemptionEntry = {
      customerId: customer.id,
      loanProductExemptionId: selectedLoanProductExemption?.id,
      customerFullName: customer.fullName,
      customerMembershipClassCustomerType: customer.membershipClassCustomerType,
      customerSerialNumber: customer.serialNumber,
      customerIndividualSalutation: customer.individualSalutation,
      customerIndividualFirstName: customer.individualFirstName,
      customerIndividualLastName: customer.individualLastName,
      customerIndividualGender: customer.individualGender,
      customerIndividualMaritalStatus: customer.individualMaritalStatus,
      id: customer.id,
      customerMembershipClassCustomerTypeDescription:
        customer.membershipClassDescription,
      paddedCustomerSerialNumber: customer.paddedSerialNumber,
      customerReference1: customer.reference1,
      customerReference2: customer.reference2,
      customerReference3: customer.reference3,
      customerIndividualGenderDescription: customer.individualGenderDescription,
      customerIndividualMaritalStatusDescription:
        customer.individualMaritalStatusDescription,
      customerIndividualIdentityCardNumber:
        customer.individualIdentityCardNumber,
      customerIndividualNationalityDescription:
        customer.individualNationalityDescription,
      customerDutyStationDescription: customer.dutyStationDescription,
      customerAddressAddressLine1: customer.addressAddressLine1,
      customerAddressAddressLine2: customer.addressAddressLine2,
      customerAddressStreet: customer.addressStreet,
      customerAddressPostalCode: customer.addressPostalCode,
      customerAddressCity: customer.addressCity,
      customerAddressEmail: customer.addressEmail,
      customerAddressLandLine: customer.addressLandLine,
      customerAddressMobileLine: customer.addressMobileLine,
      remarks: customRemarks?.remarks,
      createdBy: customer.createdBy,
      createdDate: customer.createdDate,
    }
    setLoadTabData(true)
    const { success } = await postData(
      '/LoanProductExemption/create-loan-product-exemption-entry',
      customerExemptionEntry,
      false
    )
    if (success) {
      getLoanProductExemptionEntries()
      setSelectedCustomer(null)
      setCustomRemarks({ remarks: '' })
      showNotification('Loan Product Exemption Entry', 'success')
    }
    setLoadTabData(false)
  }

  function closeModal() {
    onHideModal()
    setSelectedCustomer(null)
    setSelectedLoanProductExemption(null)
    setCustomRemarks({ remarks: '' })
  }

  return (
    <ModalTemplate
      modalClassName="modal-xl"
      modalTitle={'loanProductExemption'}
      modalMode={mode}
      handleAction={handleSubmit}
      handleClose={closeModal}
      disableClose={isBusy}
      disableCreate={isBusy}
    >
      {isBusy ? (
        <Loader />
      ) : (
        <>
          <div className="row mb-3">
            <div
              validation-message={
                gbv['loanProductExemption.Description']?.message
              }
              className="col d-flex  align-items-center with-validation"
            >
              <label className="col-1 text-capitalize">
                {localize('name')}
              </label>
              <input
                disabled={mode === 'view'}
                className="form-control"
                defaultValue={selectedLoanProductExemption?.description}
                onChange={e => {
                  clearValidation('loanProductExemption.Description')
                  setSelectedLoanProductExemption({
                    ...selectedLoanProductExemption,
                    description: e.target.value,
                  })
                }}
              />
            </div>
            <div
              validation-message={
                gbv['loanProductExemption.LoanProductId']?.message
              }
              className="col d-flex align-items-center with-validation"
            >
              <label className="col-2 text-capitalize">
                {localize('loanProduct')}
              </label>
              {mode !== 'add' ? (
                <input
                  className="form-control"
                  disabled
                  defaultValue={
                    selectedLoanProductExemption?.loanProductDescription
                  }
                />
              ) : (
                <LoanProductLookup
                  displayValue={
                    selectedLoanProductExemption?.loanProductDescription
                  }
                  onSelect={r => {
                    clearValidation('loanProductExemption.LoanProductId')
                    setSelectedLoanProductExemption({
                      ...selectedLoanProductExemption,
                      loanProductId: r.id,
                      loanProductDescription: r.description,
                    })
                  }}
                />
              )}
            </div>
          </div>

          <div
            className="p-2 mt-4"
            style={{
              border: 'solid 1px #0000001f',
              borderRadius: 10,
              position: 'relative',
            }}
          >
            <div
              className="bg-white px-2 row text-capitalize"
              style={{
                position: 'relative',
                top: -20,
                left: 30,
                maxWidth: 'fit-content',
              }}
            >
              {localize('exemptCustomerDetails')}
            </div>
            {mode !== 'view' ? (
              <>
                <CustomerPartial
                  customer={selectedCustomer}
                  onCustomerLookup={r => {
                    handleOnSelectCustomer(r)
                  }}
                  setCustomRemarks={setCustomRemarks}
                  customRemarks={customRemarks}
                  remarksVisible={true}
                  displayExtraRow={true}
                  renderConditionalField={true}
                />

                <div
                  className="d-flex justify-content-end align-items-center p-2"
                  style={{ borderRadius: 5 }}
                >
                  <button
                    onClick={() => {
                      if (selectedCustomer === null) {
                        return showNotification(
                          'Loan Product Exemption Entry',
                          'error',
                          'Sorry, but you must first select a customer'
                        )
                      } else {
                        mode === 'add'
                          ? addLoanProductExemptionEntry(selectedCustomer)
                          : addLoanProductExemptionEntryInEditMode(
                              selectedCustomer
                            )
                      }
                    }}
                    className="btn btn-success text-uppercase ms-3 px-4"
                  >
                    {localize('add')}
                  </button>
                </div>
              </>
            ) : (
              ''
            )}

            {loadTabData ? (
              <Loader />
            ) : (
              <div className="row mt-12">
                <Tab
                  tabItems={[
                    {
                      label: localize('exemptedCustomers'),
                      item: (
                        <ExemptedCustomers
                          handleOnCheckCustomerExemptionEntry={r => {
                            setExemptionEntriesToBeRemoved(r)
                          }}
                          removeSelectedExemptionEntries={r => {
                            removeExemptionEntryInEditMode()
                          }}
                          mode={mode}
                          onRemoveEntry={r => {
                            removeExemptionEntry(r)
                          }}
                          exemptedCustomers={loanProductExemptionEntries}
                          reqParams={reqParams}
                          setReqParams={setReqParams}
                          tableMeta={tableMeta}
                          getLoanProductExemptionEntries={
                            getLoanProductExemptionEntries
                          }
                        />
                      ),
                    },
                  ]}
                />
              </div>
            )}
          </div>
        </>
      )}
    </ModalTemplate>
  )
}
export default LoanProductsExemptionsModal
